import Alpine from 'alpinejs';

export const INIT_portal = () => {
    const app_lang = document.querySelector("meta[name='app_lang']").getAttribute('content');
    const app_api_url = document.querySelector("meta[name='app_api_url']").getAttribute('content');

    window.Alpine = Alpine;

    /*
     * Contractor
     */

    // Navigation
    let portalContractorNav = '#orders';

    if (window.location.hash) {
        portalContractorNav = window.location.hash;
    }

    // Store
    Alpine.store('portalContractor', {
        navigation: portalContractorNav,

        setNavigation(menuItem) {
            this.navigation = menuItem;
            window.location.hash = menuItem;
        }
    });

    // Data
    Alpine.data('portalContractor', () => ({
    }));

    /*
     * Customer
     */

    // Navigation
    let portalCustomerNav = '#orders';

    if (window.location.hash) {
        portalCustomerNav = window.location.hash;
    }

    // Store
    Alpine.store('portalCustomer', {
        navigation: portalCustomerNav,

        setNavigation(menuItem) {
            this.navigation = menuItem;
            window.location.hash = menuItem;
        }
    });

    // Data
    Alpine.data('portalCustomer', () => ({
    }));
};
